/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_Show_Card_TitleInputs */

const en_landing_how_show_card_title = /** @type {(inputs: Landing_How_Show_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow, 18:00`)
};

const pl_landing_how_show_card_title = /** @type {(inputs: Landing_How_Show_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jutro, 18:00`)
};

/**
* | output |
* | --- |
* | "Tomorrow, 18:00" |
*
* @param {Landing_How_Show_Card_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_how_show_card_title = /** @type {((inputs?: Landing_How_Show_Card_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_Show_Card_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_how_show_card_title(inputs)
	return en_landing_how_show_card_title(inputs)
});